export const musicOnHoldEnCa = {
  list: {
    title: `Music on Hold`,
    loading: `Loading playlists...`,
    error: `Error`,
    empty: `No playlists found`,
    emptyDescription: `There are currently no playlists configured for this PBX.`,
    noResults: `No results`,
    noResultsDescription: `No playlists matching your search.`,
    columnName: `Name`,
    columnType: `Type`,
    columnTracks: `Tracks`,
    columnUpdated: `Updated`,
    columnDefault: `Default`,
    columnPlayer: `Preview`,
    noPreview: `No audio`,
    previewInDetail: `Open to preview tracks`,
    defaultDisabledTooltip: `Playlist must have at least one audio track or a stream URL to be set as default.`,
    defaultCurrentTooltip: `This is the current default playlist.`,
    defaultSetTooltip: `Set as default playlist`,
    defaultBadge: `Default`,
    systemBadge: `System`,
    notPlayableBadge: `Not playable`,
    typeList: `List`,
    tracksLabel: `tracks`,
    streaming: `Streaming`,
    myPlaylists: `My Playlists`,
    systemPlaylists: `System Playlists`,
    searchPlaceholder: `Search playlists...`,
    manageTracksButton: `Audio Tracks`,
    createButton: `+ Create Playlist`,
    createDisabledTooltip: `Create playlist is not available yet.`,
    columnActions: `Actions`,
    deleteAriaLabelNamed: `Delete playlist "{{name}}"`,
    deleteConfirmTitle: `Delete playlist?`,
    deleteConfirmBody: `Delete "{{name}}"? This cannot be undone.`,
    deleteConfirm: `Delete`,
    deleteCancel: `Cancel`,
    deleteDefaultWarning: `This is the default hold-music playlist. Deleting it will fall back to the system default.`,
  },
  detail: {
    loading: `Loading playlist...`,
    error: `Error`,
    notFound: `Playlist not found.`,
    backToList: `← Back to list`,
    editButton: `Edit Playlist`,
    editDisabledTooltip: `Edit is not yet available`,
    defaultBadge: `Default`,
    systemBadge: `System`,
    generalTitle: `General Information`,
    nameLabel: `Name`,
    typeLabel: `Type`,
    typeList: `List`,
    defaultLabel: `Default`,
    defaultYes: `Yes`,
    defaultNo: `No`,
    activeLabel: `Active`,
    activeYes: `Yes`,
    activeNo: `No`,
    idLabel: `ID`,
    uuidLabel: `UUID`,
    createdLabel: `Created`,
    updatedLabel: `Updated`,
    audioTracksTitle: `Audio Tracks`,
    noAudioTracks: `There are no audio tracks associated with this playlist.`,
    manageTracksButton: `Manage Tracks`,
  },
  audioTracks: {
    title: `Audio Tracks`,
    loading: `Loading audio tracks...`,
    empty: `No audio tracks have been uploaded for this PBX.`,
    columnName: `Name`,
    columnFile: `File`,
    uploadButton: `Upload Music`,
    close: `Close`,
    nameLabel: `Track Name`,
    namePlaceholder: `Enter a track name`,
    nameRequired: `Please enter a name for the track.`,
    audioFileRequired: `Please select an audio file.`,
    fileTypeInvalid: `Only WAV or MP3 files are supported.`,
    fileSizeExceeded: `File exceeds 25 MB limit ({{size}} MB).`,
    dropzonePlaceholder: `Drag & drop a WAV or MP3 file here, or click to browse`,
    dropzoneAccepted: `WAV, MP3 (max 25 MB)`,
    removeFile: `Remove`,
    cancel: `Cancel`,
    uploadSubmit: `Upload`,
    uploading: `Uploading...`,
    uploadFailed: `Upload failed`,
    deleteConfirmTitle: `Delete audio track?`,
    deleteConfirmBody: `Delete "{{name}}"? This cannot be undone.`,
    deleteConfirm: `Delete`,
    deleteFailed: `Delete failed`,
    deleteAriaLabel: `Delete audio track`,
  },
  createModal: {
    title: `New Playlist`,
    nameLabel: `Name`,
    namePlaceholder: `Enter playlist name`,
    cancel: `Close`,
    submit: `Create Playlist`,
  },
  editModal: {
    title: `Edit Playlist`,
    nameLabel: `Name`,
    namePlaceholder: `Enter playlist name`,
    cancel: `Cancel`,
    submit: `Save Changes`,
    error: `Failed to save playlist`,
  },
  manageTracks: {
    title: `Manage Tracks`,
    inPlaylistTitle: `In this playlist`,
    availableTitle: `Available tracks`,
    noneAssigned: `No tracks have been added to this playlist yet.`,
    noTracksUploaded: `No audio tracks have been uploaded for this PBX.`,
    allAdded: `All available tracks are already in this playlist.`,
    add: `Add`,
    remove: `Remove`,
    done: `Done`,
    addFailed: `Failed to add track`,
    removeFailed: `Failed to remove track`,
  },
  trackPlay: {
    play: `Play`,
    loading: `Loading…`,
    error: `Preview unavailable`,
    close: `Close preview`,
  },
  pagination: {
    resultsPerPage: `Results per page:`,
    previousPage: `Previous page`,
    nextPage: `Next page`,
    jumpToPage: `Jump to page {{page}}`,
    all: `All`,
  },
} as const
